import React, { useState } from 'react'

export default function TextForm(props) {

  const [text, setText] = useState('');

  const handleUpClick = ()=>{
    // console.log("Uppercase was clicked"+ text);
    let newText = text.toUpperCase();
    setText(newText);
    props.showAlert("Converted to Uppercase", "success");
  }
  const handleLowClick = ()=>{
    // console.log("Lowercase was clicked"+ text);
    let newText = text.toLowerCase();
    setText(newText);
    props.showAlert("Converted to Lowercase", "success");
  }
  const handleClear= ()=>{
    // console.log("Cleared");
    let newText = "";
    setText(newText);
    props.showAlert("Text cleared", "success");
  }
  const handleExtraSpaces= ()=>{
    // console.log("Removed Extra spaces");
    let newText = text.split(/[ ]+/);
    setText(newText.join(" "));
    props.showAlert("Removed extra spaces", "success");
  }
  const handleCopy= ()=>{
    // console.log("Copied");
    let text = document.getElementById("myBox");
    text.select();
    navigator.clipboard.writeText(text.value);
    props.showAlert("Copied to Clipboard", "success");
  }
  const handleOnChange = (event)=>{
    // console.log("On change");
    setText(event.target.value);
  }
  return (
    <>
    <div className = "container" style={{color: props.mode==='light'?'#343a40':'white'}}>
    <h1>{props.heading}</h1>
    <div className="mb-3">
        <textarea className="form-control" value ={text} onChange={handleOnChange} style ={{backgroundColor: props.mode==='light'?'white':'#05505a',color: props.mode==='light'?'#343a40':'white' }} id="myBox" rows="8"></textarea>
    </div>
    <button className="btn btn-primary mx-1" onClick={handleUpClick}>Convert to Uppercase</button>
    <button className="btn btn-primary mx-1" onClick={handleLowClick}>Convert to Lowercase</button>
    <button className="btn btn-primary mx-1" onClick={handleClear}>Clear</button>
    <button className="btn btn-primary mx-1" onClick={handleCopy}>Copy Text</button>
    <button className="btn btn-primary mx-1" onClick={handleExtraSpaces}>Remove Extra Spaces</button>
    </div>
    <div className="container my-4" style={{color: props.mode==='light'?'#343a40':'white'}}>
        <h2>Your text summary</h2>
        <p>{text.split(" ").length} words and {text.length} characters</p>
        <p>{0.008*(text.split(" ").length)} mins read</p>
        <h2>Preview</h2>
        <p>{text.length>0?text:"Enter text in the textbox to preview here"}</p>
    </div>
    </>
  )
}
